import { forwardRef } from 'react';
import { Box as RadixBox } from '@radix-ui/themes';
import type { RadixComponentProps } from '@/types/radix-ui';

/**
 * Box component - wrapper around Radix UI Box
 * Provides all functionality of the original component while allowing
 * for centralized customization and future extensions.
 */
export type BoxProps = RadixComponentProps<typeof RadixBox>;

const Box = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  return <RadixBox ref={ref} {...props} />;
});

Box.displayName = 'Box';

export { Box };
